/* UFrost by LeChiller® – simulateur, formulaire et barre mobile */
(function () {
  'use strict';

  function num(v, d) { var n = parseInt(v, 10); return isNaN(n) ? d : n; }
  function fmt(n) { return Number(n).toLocaleString('en-US') + ' €'; }
  function paintRange(r) {
    var min = num(r.min, 0), max = num(r.max, 100), v = num(r.value, min);
    var p = max > min ? ((v - min) / (max - min)) * 100 : 0;
    var rest = r.classList.contains('ufr-range--light') ? 'rgba(155,190,193,.35)' : 'rgba(255,255,255,.2)';
    r.style.background = 'linear-gradient(to right,#54BCCE 0%,#54BCCE ' + p + '%,' + rest + ' ' + p + '%,' + rest + ' 100%)';
  }

  /* ---------- Simulateur ---------- */
  function initSim(root) {
    if (root.dataset.ufrInit) return; root.dataset.ufrInit = '1';
    var up = num(root.dataset.upfront, 499), mo = num(root.dataset.monthly, 150);
    var min = num(root.dataset.min, 3), max = num(root.dataset.max, 48);
    var months = num(root.dataset.default, 12);
    var range = root.querySelector('[data-sim-range]');
    var input = root.querySelector('[data-sim-number]');

    function set(v, fromInput) {
      v = Math.min(max, Math.max(min, num(v, min)));
      months = v;
      if (range) { range.value = v; paintRange(range); }
      if (input && !fromInput) input.value = v;
      root.querySelectorAll('[data-sim-months]').forEach(function (el) { el.textContent = v; });
      root.querySelectorAll('[data-sim-total]').forEach(function (el) { el.textContent = fmt(up + mo * v); });
    }
    if (range) range.addEventListener('input', function () { set(range.value); });
    if (input) {
      input.addEventListener('input', function () { if (input.value !== '') set(input.value, true); });
      input.addEventListener('blur', function () { set(input.value); });
    }
    root.querySelectorAll('[data-sim-cta]').forEach(function (b) {
      b.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('ufrost:duration', { detail: { months: months } }));
      });
    });
    set(months);
  }

  /* ---------- Formulaire ---------- */
  function initForm(root) {
    if (root.dataset.ufrInit) return; root.dataset.ufrInit = '1';
    var up = num(root.dataset.upfront, 499), mo = num(root.dataset.monthly, 150);
    var api = root.dataset.api, source = root.dataset.source || 'Shopify';
    var form = root.querySelector('[data-form]');
    var success = root.querySelector('[data-form-success]');
    var errorEl = root.querySelector('[data-form-error]');
    var submit = root.querySelector('[data-form-submit]');
    var idle = root.querySelector('[data-label-idle]');
    var loading = root.querySelector('[data-label-loading]');
    var types = Array.prototype.slice.call(root.querySelectorAll('.ufr-type'));
    var range = form ? form.querySelector('input[name="duration"]') : null;
    if (!form) return;

    function text(sel) { var el = root.querySelector(sel); return el ? el.textContent.trim() : ''; }
    function selectType(btn) {
      types.forEach(function (t) { var on = t === btn; t.classList.toggle('is-active', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    }
    function currentType() { var a = types.filter(function (t) { return t.classList.contains('is-active'); })[0]; return a ? a.dataset.type : ''; }
    function setDuration(v) {
      if (!range) return;
      v = Math.min(48, Math.max(3, num(v, 12)));
      range.value = v; paintRange(range);
      root.querySelectorAll('[data-form-months]').forEach(function (el) { el.textContent = v; });
      root.querySelectorAll('[data-form-total]').forEach(function (el) { el.textContent = (up + mo * v).toLocaleString('en-US'); });
    }
    function showError(msg) { if (errorEl) { errorEl.textContent = msg; errorEl.hidden = !msg; } }
    function setLoading(on) {
      if (submit) submit.disabled = on;
      if (idle) idle.hidden = on;
      if (loading) loading.hidden = !on;
    }

    types.forEach(function (t) { t.addEventListener('click', function () { selectType(t); }); });
    if (types.length && !currentType()) selectType(types[0]);
    if (range) { range.addEventListener('input', function () { setDuration(range.value); }); setDuration(range.value); }

    document.addEventListener('ufrost:duration', function (e) {
      if (e.detail && e.detail.months) setDuration(e.detail.months);
      if (types[1]) selectType(types[1]);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      showError('');
      var fd = new FormData(form);
      var get = function (k) { return String(fd.get(k) || '').trim(); };
      var missing = ['civility', 'firstName', 'lastName', 'company', 'postalCode', 'email', 'phone', 'priorityUsage', 'timeline', 'acquisitionMode', 'machineCount', 'message'].some(function (k) { return !get(k); });
      var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(get('email'));
      if (missing || !emailOk) { showError(text('[data-msg-required]')); return; }
      if (!api) { showError(text('[data-msg-network]')); return; }

      var duration = range ? num(range.value, 12) : 12;
      var payload = {
        requestType: currentType(),
        sector: get('sector'),
        civility: get('civility'),
        postalCode: get('postalCode'),
        firstName: get('firstName'),
        lastName: get('lastName'),
        company: get('company'),
        email: get('email'),
        phone: get('phone'),
        duration: duration,
        totalCost: up + mo * duration,
        message: get('message'),
        priorityUsage: get('priorityUsage'),
        timeline: get('timeline'),
        acquisitionMode: get('acquisitionMode'),
        machineCount: get('machineCount'),
        source: source
      };

      setLoading(true);
      fetch(api, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (res) {
          return res.text().then(function (t) {
            var data = {}; try { data = t ? JSON.parse(t) : {}; } catch (err) { data = {}; }
            return { ok: res.ok, data: data };
          });
        })
        .then(function (r) {
          setLoading(false);
          if (r.ok && r.data.success !== false) {
            form.hidden = true;
            if (success) { success.hidden = false; success.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          } else {
            showError(r.data.message || text('[data-msg-network]'));
          }
        })
        .catch(function () { setLoading(false); showError(text('[data-msg-network]')); });
    });

    root.querySelectorAll('[data-form-again]').forEach(function (b) {
      b.addEventListener('click', function () {
        form.reset(); showError('');
        if (types[0]) selectType(types[0]);
        setDuration(12);
        if (success) success.hidden = true;
        form.hidden = false;
      });
    });
  }

  /* ---------- Barre mobile ---------- */
  function initBar(bar) {
    if (bar.dataset.ufrInit) return; bar.dataset.ufrInit = '1';
    var update = function () {
      var target = document.getElementById('request');
      var inView = false;
      if (target) { var r = target.getBoundingClientRect(); inView = r.top < window.innerHeight && r.bottom > 0; }
      bar.classList.toggle('is-visible', window.scrollY > 600 && !inView);
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Défilement doux ---------- */
  function initAnchors() {
    if (document.documentElement.dataset.ufrAnchors) return;
    document.documentElement.dataset.ufrAnchors = '1';
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      if (id !== 'request' && id !== 'simulator') return;
      var el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#' + id);
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-ufrost-sim]').forEach(initSim);
    scope.querySelectorAll('[data-ufrost-form]').forEach(initForm);
    scope.querySelectorAll('[data-ufrost-mbar]').forEach(initBar);
    initAnchors();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();